

























import { Component, Vue } from 'vue-property-decorator'
import { Inject } from '../../domain/di/inject'
import { TYPES } from '../../types'
import { GetTodosQry } from '../../application/queries/get-todos-qry'
import { CompleteTodoCmd } from '../../application/commands/complete-todo-cmd'
import { Id } from '../../domain/todo/id'
import { GetLocationsQry } from 'src/application/queries/get-locations-qry'

@Component({ name: 'AppTodoList' })
export default class AppTodoList extends Vue {
  @Inject(TYPES.TODOS_QUERY_GET)
  readonly getTodosQry!: GetTodosQry

  @Inject(TYPES.LOCATIONS_QUERY_GET)
  readonly getLocationsQry!: GetLocationsQry

  @Inject(TYPES.TODO_COMMAND_COMPLETE)
  readonly completeTodoCmd!: CompleteTodoCmd

  completeTodo(id: Id) {
    this.completeTodoCmd.execute(id)
  }

  get todos() {
    return this.getTodosQry.execute()
  }

  get locations() {
    return this.getLocationsQry.execute()
  }
}
